import { isValidFileSystem } from './FileSystem';
export const fileSystemApiToEntity = fileSystem => {
  if (!fileSystem) {
    throw new Error('Invalid file system', {
      cause: {
        fileSystem
      }
    });
  }
  const converted = {
    id: fileSystem.id,
    revision: fileSystem.revision,
    createdDate: fileSystem.createdDate ?? undefined,
    updatedDate: fileSystem.updatedDate ?? undefined,
    knowledge: fileSystem.knowledge ?? {},
    brain: fileSystem.brain ?? {},
    scheduler: fileSystem.scheduler ?? {},
    pulse: fileSystem.pulse ?? {}
  };
  if (isValidFileSystem(converted)) {
    return converted;
  }
  throw new Error('Invalid file system data', {
    cause: {
      converted
    }
  });
};
//# sourceMappingURL=converters.js.map